import React from 'react';
import { offerRows } from '../data/content';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="offer" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-150" data-mp="17xkz0gyqxvhc">
      <div className="mx-auto max-w-md" data-id="element-151" data-mp="1mo22s6yusxhe">
        <h2 className="text-center text-[1.6rem] font-black leading-tight tracking-tight text-stone-900 sm:text-[2.2rem]" data-id="element-152" data-mp="1mmzf07wtvb5p">
          <span aria-hidden="true" data-id="element-153" data-mp="1hqs400pkr9gw">🏆 </span>Special Launch Offer
        </h2>

        <div className="relative mt-10 rounded-3xl border-2 border-red-500 bg-white px-7 pb-8 pt-11 shadow-xl" data-id="element-154" data-mp="tz3ip4b67l9g">
          <span className="absolute -top-3 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-red-500 px-4 py-1.5 text-[10px] font-extrabold uppercase tracking-[0.14em] text-white" data-id="element-155" data-mp="p1v052m41f7o">
            Hospitality English Ready™
          </span>

          <dl data-id="element-156" data-mp="2fbeqwlknxdct">
            {offerRows.map(row => <div key={row.label} className="flex items-center justify-between gap-4 border-b border-stone-200 py-4 text-sm" data-id="element-157" data-mp="2fad27eaq4scm">
                <dt className="text-stone-700" data-id="element-158" data-mp="pk7gbmti0n9z">{row.label}</dt>
                <dd className="font-bold text-red-500" data-id="element-159" data-mp="pjp9jw97mqnt">{row.value}</dd>
              </div>)}
            <div className="flex items-center justify-between border-b border-stone-200 py-4 text-sm" data-id="element-160" data-mp="ui0i83nrqv4g">
              <dt className="font-bold uppercase tracking-wide text-stone-900" data-id="element-161" data-mp="ziwnolnrqpbz">
                Total Value:
              </dt>
              <dd className="font-bold text-amber-600 line-through" data-id="element-162" data-mp="13hnnj0jmcl2s">
                $164 USD
              </dd>
            </div>
          </dl>

          <p className="mt-6 text-center text-[11px] font-extrabold uppercase tracking-[0.16em] text-red-500" data-id="element-163" data-mp="bs12469woqd6">
            Today only
          </p>
          <p className="flex items-center justify-center gap-2 border-b border-stone-200 pb-7 pt-2" data-id="element-164" data-mp="fsb6jei1v8px">
            <span className="text-4xl leading-none" aria-hidden="true" data-id="element-165" data-mp="kn8k8yq9y695">
              🏆
            </span>
            <span className="text-6xl font-black leading-none text-red-500" data-id="element-166" data-mp="3k6t2414gcn54">
              $27
            </span>
            <span className="self-end pb-2 text-sm font-bold text-red-500" data-id="element-167" data-mp="vfh4q7ui0tjc">
              USD
            </span>
          </p>

          <p className="mt-5 text-center text-[11px] font-medium leading-relaxed text-stone-600" data-id="element-168" data-mp="qfmem6ijs7zc">
            <span aria-hidden="true" data-id="element-169" data-mp="154ijxvt7z6w9">💳 </span>Payment will be processed in your
            local currency (or the equivalent of 27 USD).
          </p>

          <CtaButton className="mt-4 w-full" data-id="element-170" data-mp="108th9jlwl9vq" />

          <p className="mt-4 text-center text-[11px] font-medium text-stone-500" data-id="element-171" data-mp="chxu4zse72ut">
            Instant Download · One-Time Payment · Lifetime Access · 7-Day
            Guarantee
          </p>
        </div>
      </div>
    </section>;
}